export enum PdfSettingsRoundingEnum {
  LIGHT = 'LIGHT',
  MEDIUM = 'MEDIUM',
  STRONG = 'STRONG',
}
